export const qrCodeNewIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 14V12H7V14H5ZM3 12V10H5V12H3ZM12 5V3H14V5H12ZM4.5 7.5H7.5V4.5H4.5V7.5ZM3 9V3H9V9H3ZM4.5 19.5H7.5V16.5H4.5V19.5ZM3 21V15H9V21H3ZM16.5 7.5H19.5V4.5H16.5V7.5ZM15 9V3H21V9H15ZM9 14V12H7V10H11V14H9ZM10 9V5H12V7H14V9H10ZM5.25 6.75V5.25H6.75V6.75H5.25ZM5.25 18.75V17.25H6.75V18.75H5.25ZM17.25 6.75V5.25H18.75V6.75H17.25ZM16 21V18H13V16H16V13H18V16H21V18H18V21H16Z"
    fill="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
